export const OFFER_START = Date.parse('2026-10-06T00:00:00-07:00');
export const OFFER_END = Date.parse('2026-10-16T00:00:00-07:00');
export const GIFT_KEY = 'Halloween bead gift';
export const SETS_KEY = 'Halloween bead gift sets';
export const BEADS_KEY = 'Halloween bead gift beads';
export const REQUESTED_KEY = 'Halloween bead gift requested at';
export function reelCount(cart) {
  return (cart.items || []).reduce((total, item) => total +
    (['Badge Reel', 'Mini Badge Reel'].includes(item.product_type) ? Math.max(0, Number(item.quantity) || 0) : 0), 0);
}
export function offerActive(now = Date.now()) { return now >= OFFER_START && now < OFFER_END; }
export function giftAttributes(cart, optIn, now = Date.now()) {
  const count = reelCount(cart);
  const selected = Boolean(optIn && count > 0 && offerActive(now));
  const existingDate = cart.attributes?.[REQUESTED_KEY];
  const validDate = Number.isFinite(Date.parse(existingDate)) && offerActive(Date.parse(existingDate));
  return {
    [GIFT_KEY]: selected ? 'Yes' : '',
    [SETS_KEY]: selected ? String(count) : '',
    [BEADS_KEY]: selected ? String(count * 4) : '',
    [REQUESTED_KEY]: selected ? (validDate ? existingDate : new Date(now).toISOString()) : ''
  };
}
if (typeof window !== 'undefined' && typeof document !== 'undefined' && !customElements.get('rc-halloween-gift')) {
  let chain = Promise.resolve();
  let jobs = 0;
  let latestCart = null;
  let confirmedOptIn = null;
  let bypassSubmit = false;
  const root = () => window.Shopify?.routes?.root || '/';
  const cards = () => [...document.querySelectorAll('rc-halloween-gift')];
  const paint = (cart, message = '', error = false) => {
    const count = reelCount(cart);
    const active = count > 0 && offerActive();
    const selected = active && cart.attributes?.[GIFT_KEY] === 'Yes';
    cards().forEach(card => {
      card.hidden = !active;
      card.setAttribute('aria-busy', String(jobs > 0));
      const checkbox = card.querySelector('[data-gift-checkbox]');
      checkbox.checked = selected;
      checkbox.disabled = jobs > 0;
      const quantity = card.querySelector('[data-gift-quantity]');
      quantity.hidden = !selected;
      quantity.textContent = card.dataset.quantityTemplate.replace('__COUNT__', count).replace('__BEADS__', count * 4);
      const status = card.querySelector('[data-gift-status]');
      status.hidden = !message;
      status.textContent = card.dataset[message] || '';
      status.dataset.error = String(error);
    });
  };
  const request = async (path, options = {}) => {
    const response = await fetch(root() + path, { ...options, credentials:'same-origin' });
    if (!response.ok) throw new Error('Gift choice request failed');
    const result = await response.json();
    if (result.errors) throw new Error('Gift choice update failed');
    return result;
  };
  const reconcile = async optIn => {
    let cart = await request('cart.js', {cache:'no-store'});
    const choice = optIn ?? (cart.attributes?.[GIFT_KEY] === 'Yes');
    const attributes = giftAttributes(cart, choice);
    if (Object.entries(attributes).some(([key,value]) => (cart.attributes?.[key] || '') !== value)) {
      cart = await request('cart/update.js', {
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body:JSON.stringify({attributes})
      });
    }
    latestCart = cart;
    confirmedOptIn = cart.attributes?.[GIFT_KEY] === 'Yes';
    return cart;
  };
  const schedule = optIn => {
    jobs++;
    if (latestCart) paint(latestCart, 'saving');
    cards().forEach(card => {
      card.setAttribute('aria-busy','true');
      card.querySelector('[data-gift-checkbox]').disabled = true;
    });
    const task = chain.catch(() => {}).then(() => reconcile(optIn));
    chain = task;
    return task.then(cart => {
      jobs--;
      paint(cart, optIn === undefined ? '' : 'saved');
      return cart;
    }, error => {
      jobs--;
      if (latestCart) paint(latestCart, 'error', true);
      else cards().forEach(card => {
        card.querySelector('[data-gift-checkbox]').disabled = false;
        const status = card.querySelector('[data-gift-status]');
        status.hidden = false;
        status.textContent = card.dataset.error;
        status.dataset.error = 'true';
      });
      throw error;
    });
  };
  class HalloweenGift extends HTMLElement {
    connectedCallback() {
      if (latestCart) paint(latestCart);
      if (!jobs) schedule().catch(() => {});
    }
  }
  customElements.define('rc-halloween-gift', HalloweenGift);
  document.addEventListener('change', event => {
    if (!event.target.matches?.('rc-halloween-gift [data-gift-checkbox]')) return;
    schedule(event.target.checked).catch(() => {});
  });
  document.addEventListener('cart:update', () => { schedule().catch(() => {}); });
  document.addEventListener('submit', async event => {
    if (bypassSubmit || event.submitter?.name !== 'checkout' || event.target.id !== 'cart-form') return;
    event.preventDefault();
    const form = event.target;
    const submitter = event.submitter;
    try {
      await schedule();
      if (!form.isConnected) return;
      bypassSubmit = true;
      form.requestSubmit(submitter?.isConnected ? submitter : undefined);
    } catch {
    } finally { bypassSubmit = false; }
  }, true);
  window.addEventListener('pageshow', () => { if (cards().length) schedule().catch(() => {}); });
  window.addEventListener('focus', () => {
    if (cards().length || confirmedOptIn) schedule().catch(() => {});
  });
  setTimeout(() => {
    if (confirmedOptIn) schedule().catch(() => {});
  }, Math.min(Math.max(0, OFFER_END - Date.now()), 2147483647));
}
